import classNames from "classnames"

import { Subtitle, Title2 } from "@bounce/design-system"
import type { Nullable } from "@bounce/util"

import type { ButtonProps } from "../../Inputs/Button/Button"
import { Button } from "../../Inputs/Button/Button"
import type { PNImageProps } from "../PNImage/PNImage"
import { PNImage } from "../PNImage/PNImage"

import ArrowIcon from "./assets/arrow.svg"

export type CTAProps = {
  src?: PNImageProps["src"]
  title?: Nullable<string>
  subtitle?: Nullable<string>
  ctaLabel: Nullable<string>
  ctaHref?: Nullable<string>
  ctaRel?: Nullable<string>
  ctaOnClick?: (ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  sectionRef?: React.Ref<HTMLElement>
  className?: string
} & Pick<ButtonProps<"a">, "LeftIcon" | "RightIcon">

export const CTA = ({
  title,
  subtitle,
  ctaHref,
  ctaLabel,
  ctaRel,
  ctaOnClick,
  LeftIcon,
  RightIcon,
  src,
  sectionRef,
  className,
}: CTAProps) => {
  return (
    <section ref={sectionRef} className={classNames("w-full bg-neutral-100 py-[60px]", className)}>
      <div className="mx-auto flex w-full max-w-screen-xl flex-col items-center gap-x-16 px-6 md:flex-row md:gap-x-10">
        {!!src && (
          <PNImage
            src={src}
            height={296}
            width={296}
            imgixParams={{ fit: "max", h: 296 }}
            loading="lazy"
            className="mb-10 w-[305px] object-contain md:mb-0 "
          />
        )}
        <div className="flex w-full flex-col justify-center">
          <Title2 className="flex max-w-4xl text-left">{title}</Title2>
          {!!subtitle && (
            <Subtitle className="mt-2 max-w-4xl text-left text-neutral-800 md:mt-2.5 xl:mt-3">{subtitle}</Subtitle>
          )}
          {!!ctaLabel && (
            <div className="flex w-full">
              <Button
                href={ctaHref || "#"}
                rel={ctaRel ? ctaRel : undefined}
                onClick={ctaOnClick ? ctaOnClick : () => {}}
                className="mt-11 w-full md:w-fit xl:mt-16"
                LeftIcon={LeftIcon}
                RightIcon={RightIcon}>
                {ctaLabel}
              </Button>
              <div className="relative left-2 top-5 hidden xl:flex">
                <ArrowIcon height={82} />
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
